<template>
  <div class="ntax-ci">
    <img src="@/assets/images/198x31.png" alt="홈택스 자료 전송" />
    <img
      v-if="userType == 'CAK'"
      src="@/assets/images/cak_logo.png"
      alt="대한건설협회로고"
      style="float: right;"
    />
    <img
      v-if="userType == 'KMC'"
      src="@/assets/images/kmc_logo.png"
      alt="대한기계설비건설협회로고"
      style="float: right;"
    />
    <img
      v-if="userType == 'EGIC'"
      src="@/assets/images/egic_logo.png"
      alt="엔지니어링공제조합로고"
      style="float: right;"
    />
    <img
      v-if="userType == 'KOSCA'"
      src="@/assets/images/logo-kosca-sub.png"
      alt="전문건설협회로고"
      style="float: right;"
    />
  </div>
  <div class="ntax-header">
    <div class="header-container">

      <ul v-if="userType != 'RS'" class="ntax-navi">
        <li>
          <a href="#" @click.prevent="goToPage(isLimited ? '/niceTaxAgree.do' : '/niceTaxSendMain.do')">
            <span class="glyphicon glyphicon-cloud-upload"></span> 자료전송
          </a>
        </li>
        <li v-if="!isLimited">
          <a href="#" @click.prevent="checkLogin">
            <span class="glyphicon glyphicon-search"></span> 전송내역조회
          </a>
        </li>
        <li v-if="!isLimited">
          <a href="#" @click.prevent="goToPage('/niceTaxUserGuide.do')">
            <span class="glyphicon glyphicon-list-alt"></span> 사용자가이드
          </a>
        </li>
        <li>
          <a href="#" @click.prevent="goToMain">
            <span class="glyphicon glyphicon-home"></span> 홈
          </a>
        </li>
      </ul>

      <ul v-else-if="isLogin" class="ntax-navi">
        <li>
          <a href="#" @click.prevent="goToPage('/niceTaxInstitution.do')">
            <span class="glyphicon glyphicon-cloud-upload"></span> 자료전송
          </a>
        </li>
        <li v-if="!isLimited">
          <a href="#" @click.prevent="checkLogin">
            <span class="glyphicon glyphicon-search"></span> 전송내역조회
          </a>
        </li>
        <li v-if="!isLimited">
          <a href="#" @click.prevent="goToPage('/niceTaxCertInfo.do')">
            <span class="glyphicon glyphicon-lock"></span> 공동인증서관리
          </a>
        </li>
        <li>
          <a href="#" @click.prevent="goToMain">
            <span class="glyphicon glyphicon-log-out"></span> 로그아웃
          </a>
        </li>
      </ul>

      <ul v-else class="ntax-navi">

      </ul>
      
      
      
    </div>
  </div>
  <LoginModal ref="LoginModal" />
</template>

<script>
import LoginModal from "@/components/common/LoginModal.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    LoginModal,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("sessionStore", ["userType"]),
    ...mapGetters("userStore", ["isLogin"]),
    isLimited() {
      return ["CAK", "KMC", "EGIC", "CRP", "KOSCA", "ICMS"].includes(
        this.userType
      );
    },
  },
  methods: {
    goToPage(path) {
      this.$router.push(path);
    },
    goToMain() {
      if (confirm("첫페이지로 이동하시겠습니까?")) {
        this.$router.push("/niceTaxMain.do");
      }
    },
    checkLogin() {
      if (this.isLogin) {
        this.$router.push("/niceTaxList.do");
      } else {
        this.$refs.LoginModal.open("/niceTaxList.do");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
}
</style>